import { FONT_FAMILY } from '../constants';

const axisColor = '#ccc';
const axisLabelColor = '#000';

export default {
  _unit: '',
  tooltip: {
    trigger: 'axis',
    textStyle: { fontFamily: FONT_FAMILY },
  },
  xAxis: {
    type: 'time',
    splitNumber: 4,
    axisLabel: {
      color: axisLabelColor,
      fontSize: 12,
      showMinLabel: false,
      fontFamily: FONT_FAMILY,
    },
    splitLine: {
      show: false,
    },
    axisTick: {
      lineStyle: {
        color: axisColor,
      },
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: axisColor,
      },
    },
  },
  yAxis: {
    type: 'log',
    axisLabel: {
      color: axisLabelColor,
      fontSize: 12,
      fontFamily: FONT_FAMILY,
    },
    splitLine: {
      show: true,
    },
    axisTick: {
      show: false,
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: axisColor,
      },
    },
  },
  grid: {
    top: 40,
    bottom: 35,
    left: 50,
    right: 20,
  },
};

export const series = {
  name: '',
  type: 'bar',
  barGap: '-100%',
  itemStyle: {
    color: '#fff',
  },
  data: [],
  large: true,
};
